<template lang="pug">
b-modal#editPromotionBanner(
  ref="editPromotionBanner"
  :title="$t('ui.combine.edit_promotion_banner')"
  centered
  no-fade
  no-close-on-backdrop
  size="lg"
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown"
)
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    .row.mb-3
      div.col-sm-12.col-md-4.col-lg-4
        b-form-group(:label="$t('ui.category')").mb-0
          PromotionCategoryLookup(
            ref="category"
            size="sm"
            required
            type="array"
            :dirty="$v.category.$dirty"
            :error="$v.category.$error"
            v-model.trim.lazy="$v.category.$model"
            :disabled="loading"
          )
          ValidateResult(:value="$v.category" :name="$t('ui.category')")

    .row
      .col-12
        ul#editorTab.nav.nav-tabs(role='tablist')
          li.nav-item
            a#enPromoEdit-tab.nav-link(data-toggle='tab' href='#enPromoEdit-content' role='tab' aria-controls='enPromoEdit' aria-selected='false' @click="setTab('en')" :class="activeTab == 'en' ? 'active' : ''") {{ $t("ui.en") }}
          li.nav-item
            a#cnPromoEdit-tab.nav-link(data-toggle='tab' href='#cnPromoEdit-content' role='tab' aria-controls='cnPromoEdit' aria-selected='false' @click="setTab('cn')" :class="activeTab == 'cn' ? 'active' : ''") {{ $t("ui.cn") }}
          li.nav-item
            a#localPromoEdit-tab.nav-link(data-toggle='tab' href='#localPromoEdit-content' role='tab' aria-controls='localPromoEdit' aria-selected='false' @click="setTab('local')" :class="activeTab == 'local' ? 'active' : ''") {{ $t("ui.local") }}
        #editorcontent.tab-content.tab-bordered
          #enPromoEdit-content.tab-pane(:class="activeTab == 'en' ? 'active show' : 'fade'" role='tabpanel' aria-labelledby='enPromoEdit-tab')
            div.d-flex.flex-wrap
              b-form-group.w-100(:label="$t('ui.title')").mb-0
                ckeditor(
                  v-model="en_title"
                  :config="enTitleConfig"
                  :disabled="loading"
                  )
              b-form-group.w-100(:label="$t('ui.body')").mb-0
                ckeditor(
                  v-model="en_body"
                  :config="enBodyConfig"
                  :disabled="loading"
                  )
              .alert.alert-warning.p-1.mb-2.w-100(v-if="imgSize && imgSize[themeCode]") *{{ $t("message.banner_size_tooltips", { size: imgSize[themeCode][5] }) }}
              b-form-group.w-100(:label="$t('ui.image')").mb-0
                b-form-file(
                  :dirty="$v.en_image.$dirty"
                  :error="$v.en_image.$error"
                  v-model.trim.lazy="$v.en_image.$model"
                  ref="file"
                  accept="image/jpeg, image/png, image/jpg"
                  @change="onSelectEn"
                  v-if="enImageSrc == null"
                )
                small.form-text.text-muted {{ $t('message.tooltips_upload_size') }} 
                ValidateResult(:value="$v.en_image" :name="$t('ui.en_image')")
                SubmitButton(
                  :loading="loading"
                  icon="fa fa-times"
                  :text="$t('ui.remove')"
                  type="button"
                  @click="removeEnImage()"
                  variant="danger"
                  size="sm"
                  v-if="enImageSrc != null"
                  )
                br
                b-img.w-50.h-50(v-if="enImageSrc != null" :src="enImageSrc")

          #cnPromoEdit-content.tab-pane(:class="activeTab == 'cn' ? 'active show' : 'fade'" role='tabpanel' aria-labelledby='cnPromoEdit-tab')
            div.d-flex.flex-wrap
              b-form-group.w-100(:label="$t('ui.title')").mb-0
                ckeditor(
                  v-model="cn_title"
                  :config="cnTitleConfig"
                  :disabled="loading"
                  )
              b-form-group.w-100(:label="$t('ui.body')").mb-0
                ckeditor(
                  v-model="cn_body"
                  :config="cnBodyConfig"
                  :disabled="loading"
                  )
              .alert.alert-warning.p-1.mb-2.w-100(v-if="imgSize && imgSize[themeCode]") *{{ $t("message.banner_size_tooltips", { size: imgSize[themeCode][5] }) }}
              b-form-group.w-100(:label="$t('ui.image')").mb-0
                b-form-file(
                  :dirty="$v.cn_image.$dirty"
                  :error="$v.cn_image.$error"
                  v-model.trim.lazy="$v.cn_image.$model"
                  ref="file"
                  accept="image/jpeg, image/png, image/jpg"
                  @change="onSelectCn"
                  v-if="cnImageSrc == null"
                )
                small.form-text.text-muted {{ $t('message.tooltips_upload_size') }} 
                ValidateResult(:value="$v.cn_image" :name="$t('ui.cn_image')")
                SubmitButton(
                  :loading="loading"
                  icon="fa fa-times"
                  :text="$t('ui.remove')"
                  type="button"
                  @click="removeCnImage()"
                  variant="danger"
                  size="sm"
                  v-if="cnImageSrc != null"
                  )
                br
                b-img.w-50.h-50(v-if="cnImageSrc != null" :src="cnImageSrc")

          #localPromoEdit-content.tab-pane(:class="activeTab == 'local' ? 'active show' : 'fade'" role='tabpanel' aria-labelledby='localPromoEdit-tab')
            div.d-flex.flex-wrap
              b-form-group.w-100(:label="$t('ui.title')").mb-0
                ckeditor(
                  v-model="local_title"
                  :config="localTitleConfig"
                  :disabled="loading"
                  )
              b-form-group.w-100(:label="$t('ui.body')").mb-0
                ckeditor(
                  v-model="local_body"
                  :config="localBodyConfig"
                  :disabled="loading"
                  )
              .alert.alert-warning.p-1.mb-2.w-100(v-if="imgSize && imgSize[themeCode]") *{{ $t("message.banner_size_tooltips", { size: imgSize[themeCode][5] }) }}
              b-form-group.w-100(:label="$t('ui.image')").mb-0
                b-form-file(
                  :dirty="$v.local_image.$dirty"
                  :error="$v.local_image.$error"
                  v-model.trim.lazy="$v.local_image.$model"
                  ref="file"
                  accept="image/jpeg, image/png, image/jpg"
                  @change="onSelectLocal"
                  v-if="localImageSrc == null"
                )
                small.form-text.text-muted {{ $t('message.tooltips_upload_size') }} 
                ValidateResult(:value="$v.local_image" :name="$t('ui.local_image')")
                SubmitButton(
                  :loading="loading"
                  icon="fa fa-times"
                  :text="$t('ui.remove')"
                  type="button"
                  @click="removeLocalImage()"
                  variant="danger"
                  size="sm"
                  v-if="localImageSrc != null"
                  )
                br
                b-img.w-50.h-50(v-if="localImageSrc != null" :src="localImageSrc")

        div.row
          div.col
            b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
  div(slot="modal-cancel")
    SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, alphaNum, minLength, maxLength, integer, numeric, helpers, decimal, minValue, maxValue, requiredIf } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
import CMSBannerCount from "@/library/CMSBannerCount";
import PromotionCategoryLookup from "@/library/PromotionCategoryLookup";
import { VueEditor, Quill } from "vue2-editor";
import $ from 'jquery';
const alphaNumWithSpace = helpers.regex("alphaNumWithSpace", /^[a-z\d\-_\s]+$/i);
const fileSizeValidation = (value, vm) =>  {
  if (!value) {
    return true;
  }
  let file = value;
  return (file.size < 1048576);
};
const base64Encode = data =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(data);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });


export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput,
    CMSBannerCount,
    VueEditor,
    PromotionCategoryLookup
  },
  props: {
    item: {
      type: Object
    },
  },
  data() {
    return {
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      en_title: "",
      en_body: "",
      en_image: null,
      cn_title: "",
      cn_body: "",
      cn_image: null,
      local_title: "",
      local_body: "",
      local_image: null,
      localTitleConfig: {
        versionCheck: false,
        height: '100px',
        format_tags: 'p;h1;h2;h3;h4;h5;h6;pre;address;div',
        extraPlugins: 'colorbutton,colordialog,uploadimage,filebrowser',
        filebrowserUploadUrl: config.uploadEditorImageUrl,
        filebrowserImageUploadUrl: config.uploadEditorImageUrl,
        removePlugins: 'source,sourcearea',
        on: {
          instanceReady: function (evt) {
            const editor = evt.editor;
            this.setupEditorSecurity(editor);
          }.bind(this),
        }
      },
      enTitleConfig: {
        versionCheck: false,
        height: '100px',
        format_tags: 'p;h1;h2;h3;h4;h5;h6;pre;address;div',
        extraPlugins: 'colorbutton,colordialog,uploadimage,filebrowser',
        filebrowserUploadUrl: config.uploadEditorImageUrl,
        filebrowserImageUploadUrl: config.uploadEditorImageUrl,
        removePlugins: 'source,sourcearea',
        on: {
          instanceReady: function (evt) {
            const editor = evt.editor;
            this.setupEditorSecurity(editor);
          }.bind(this),
        }
      },
      cnTitleConfig: {
        versionCheck: false,
        height: '100px',
        format_tags: 'p;h1;h2;h3;h4;h5;h6;pre;address;div',
        extraPlugins: 'colorbutton,colordialog,uploadimage,filebrowser',
        filebrowserUploadUrl: config.uploadEditorImageUrl,
        filebrowserImageUploadUrl: config.uploadEditorImageUrl,
        removePlugins: 'source,sourcearea',
        on: {
          instanceReady: function (evt) {
            const editor = evt.editor;
            this.setupEditorSecurity(editor);
          }.bind(this),
        }
      },
      localBodyConfig: {
        versionCheck: false,
        height: '200px',
        format_tags: 'p;h1;h2;h3;h4;h5;h6;pre;address;div',
        extraPlugins: 'colorbutton,colordialog,uploadimage,filebrowser',
        filebrowserUploadUrl: config.uploadEditorImageUrl,
        filebrowserImageUploadUrl: config.uploadEditorImageUrl,
        removePlugins: 'source,sourcearea',
        on: {
          instanceReady: function (evt) {
            const editor = evt.editor;
            this.setupEditorSecurity(editor);
          }.bind(this),
        }
      },
      enBodyConfig: {
        versionCheck: false,
        height: '200px',
        format_tags: 'p;h1;h2;h3;h4;h5;h6;pre;address;div',
        extraPlugins: 'colorbutton,colordialog,uploadimage,filebrowser',
        filebrowserUploadUrl: config.uploadEditorImageUrl,
        filebrowserImageUploadUrl: config.uploadEditorImageUrl,
        removePlugins: 'source,sourcearea',
        on: {
          instanceReady: function (evt) {
            const editor = evt.editor;
            this.setupEditorSecurity(editor);
          }.bind(this),
        }
      },
      cnBodyConfig: {
        versionCheck: false,
        height: '200px',
        format_tags: 'p;h1;h2;h3;h4;h5;h6;pre;address;div',
        extraPlugins: 'colorbutton,colordialog,uploadimage,filebrowser',
        filebrowserUploadUrl: config.uploadEditorImageUrl,
        filebrowserImageUploadUrl: config.uploadEditorImageUrl,
        removePlugins: 'source,sourcearea',
        on: {
          instanceReady: function (evt) {
            const editor = evt.editor;
            this.setupEditorSecurity(editor);
          }.bind(this),
        }
      },
      file: "",
      en_image_url: "",
      cn_image_url: "",
      local_image_url: "",
      enImageName: "",
      cnImageName: "",
      localImageName: "",
      enImageSrc: null,
      cnImageSrc: null,
      localImageSrc: null,
      banner_id: 0,
      category: "",
      activeTab: "en"
    };
  },
  computed: {
    imgSize() {
      return config.bannerDimension;
    },
    themeCode() {
      return this.$store.getters.selectedTheme;
    },
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    },
  },
  validations: {
    // en_title: {
    //   required
    // },
    // en_body: {
    //   required
    // },
    category: {
      required
    },
    en_image: {
      required : requiredIf(function () {
        return this.enImageSrc == null;
      }),
      fileSizeValidation
    },
    cn_image: {
      fileSizeValidation
    },
    local_image: {
      fileSizeValidation
    }
  },
  watch: {
    en_image(newValue, oldValue) {
      if (newValue !== oldValue) {
        if (newValue) {
          base64Encode(newValue)
            .then(value => {
              this.enImageSrc = value;
            })
            .catch(() => {
              this.enImageSrc = null;
            });
        } else {
          this.enImageSrc = null;
        }
      }
    },
    cn_image(newValue, oldValue) {
      if (newValue !== oldValue) {
        if (newValue) {
          base64Encode(newValue)
            .then(value => {
              this.cnImageSrc = value;
            })
            .catch(() => {
              this.cnImageSrc = null;
            });
        } else {
          this.cnImageSrc = null;
        }
      }
    },
    local_image(newValue, oldValue) {
      if (newValue !== oldValue) {
        if (newValue) {
          base64Encode(newValue)
            .then(value => {
              this.localImageSrc = value;
            })
            .catch(() => {
              this.localImageSrc = null;
            });
        } else {
          this.localImageSrc = null;
        }
      }
    }
  },
  methods: {
    setTab(tab) {
      this.activeTab = tab;
    },
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    removeEnImage() {
      this.en_image = null;
      this.en_image_url = "";
      this.enImageName = "";
      this.enImageSrc = null;
    },
    removeCnImage() {
      this.cn_image = null;
      this.cn_image_url = "";
      this.cnImageName = "";
      this.cnImageSrc = null;
    },
    removeLocalImage() {
      this.local_image = null;
      this.local_image_url = "";
      this.localImageName = "";
      this.localImageSrc = null;
    },
    onSelectEn(evt) {
      if(evt.target.files.length > 0){
        this.enImageName = evt.target.files[0].name;
        // this.file = file;
      }else{
        return
      }
    },
    onSelectCn(evt) {
      if(evt.target.files.length > 0){
        this.cnImageName = evt.target.files[0].name;
      }else{
        return
      }
    },
    onSelectLocal(evt) {
      if(evt.target.files.length > 0){
        this.localImageName = evt.target.files[0].name;
      }else{
        return
      }
    },
    submit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.confirmSubmit();
      }
    },
    proceed() {
      let url = config.cmsPromotionBannerEditUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        banner_id: this.banner_id,
        en_title: this.en_title,
        en_body: this.en_body,
        en_image_url: this.en_image_url,
        cn_title: this.cn_title,
        cn_body: this.cn_body,
        cn_image_url: this.cn_image_url,
        local_title: this.local_title,
        local_body: this.local_body,
        local_image_url: this.local_image_url,
        category: this.category,
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.$emit("clicked");
                this.$refs.editPromotionBanner.hide();
              } else {
                this.$helpers.handleFeedback(this.feedback.status);
                this.$emit("failed", "edit_promotion_banner", this.feedback.status);
                this.$refs.editPromotionBanner.hide();
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    async uploadEnImage() {
      if (this.enImageName == "")
        return;

      const formData = new FormData();
      formData.append("file", this.en_image);
      this.loading = true;
      try {
        await this.$http
          .post(config.uploadImageUrl, formData)
          .then(function(response) {
            this.loading = false;
            if (response.data.file.filename) {
              this.en_image_url = response.data.file.filename;
            }
            // this.proceed();
          });
      } catch (err) {
        this.feedback.success = false;
        this.feedback.status = errorTags.request.failed;
      }
    },
    async uploadCnImage() {
      if (this.cnImageName == "")
        return;

      const formData = new FormData();
      formData.append("file", this.cn_image);
      this.loading = true;
      try {
        await this.$http
          .post(config.uploadImageUrl, formData)
          .then(function(response) {
            this.loading = false;
            if (response.data.file.filename) {
              this.cn_image_url = response.data.file.filename;
            }
            // this.proceed();
          });
      } catch (err) {
        this.feedback.success = false;
        this.feedback.status = errorTags.request.failed;
      }
    },
    async uploadLocalImage() {
      if (this.localImageName == "")
        return;

      const formData = new FormData();
      formData.append("file", this.local_image);
      this.loading = true;
      try {
        await this.$http
          .post(config.uploadImageUrl, formData)
          .then(function(response) {
            this.loading = false;
            if (response.data.file.filename) {
              this.local_image_url = response.data.file.filename;
            }
            // this.proceed();
          });
      } catch (err) {
        this.feedback.success = false;
        this.feedback.status = errorTags.request.failed;
      }
    },
    async confirmSubmit() {
      const p1 = this.uploadEnImage();
      const p2 = this.uploadCnImage();
      const p3 = this.uploadLocalImage();
      const someResult = await p1;
      const anotherResult = await p2;
      const anotherResult2 = await p3;

      this.proceed();
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
      this.activeTab = 'en';
    },
    shown: function() {
      this.banner_id = this.item.id;
      this.en_title = this.item.en_title;
      this.en_body = this.item.en_body;
      this.enImageSrc = this.item.en_image_url != null ? config.viewImageUrl + this.item.en_image_url : null;
      this.en_image_url = this.item.en_image_url;
      this.cn_title = this.item.cn_title;
      this.cn_body = this.item.cn_body;
      this.cnImageSrc = this.item.cn_image_url != null ? config.viewImageUrl + this.item.cn_image_url : null;
      this.cn_image_url = this.item.cn_image_url;
      this.local_title = this.item.local_title;
      this.local_body = this.item.local_body;
      this.localImageSrc = this.item.local_image_url != null ? config.viewImageUrl + this.item.local_image_url : null;
      this.local_image_url = this.item.local_image_url;
      this.category = this.item.category;
      this.enImageName = "";
      this.cnImageName = "";
      this.localImageName = "";
      this.$v.$reset();
      $("#editPromotionBanner").find('.modal-content').first().removeAttr('tabindex');
    },
    setupEditorSecurity(editor) {
      // Block paste files/base64 images
      editor.on('paste', function (e) {
        if (e.data && e.data.dataTransfer && typeof e.data.dataTransfer.getFiles === 'function') {
          const files = e.data.dataTransfer.getFiles();
          if (files && files.length > 0) {
            e.cancel();
            return;
          }
        }
        if (e.data && e.data.dataValue && e.data.dataValue.indexOf('data:image') !== -1) {
          e.cancel();
        }
      });

      // Block drag & drop files/images
      editor.on('contentDom', function () {
        editor.document.on('drop', function (e) {
          const dataTransfer = e.data.$.dataTransfer;
          if (dataTransfer && dataTransfer.files && dataTransfer.files.length > 0) {
            e.data.preventDefault(true);
          }
        });
      });

      // Additional security measures
      editor.on('beforeCommandExec', function (evt) {
        const command = evt.data.name;
        // Block potentially dangerous commands
        if (command === 'execCommand' || command === 'insertHtml') {
          // Add additional validation if needed
        }
      });

      if (editor._dialogSecurityHooked) return;
      editor._dialogSecurityHooked = true;

      // Hook dialog definition for upload button override
      editor.on('dialogDefinition', function (ev) {
        const dialogName = ev.data.name;
        const dialogDefinition = ev.data.definition;

        if (dialogName === 'image') {
          const uploadTab = dialogDefinition.getContents('Upload');
          const uploadButton = uploadTab.get('uploadButton');

          // Ensure upload input exists
          if (!uploadTab.get('upload')) {
            uploadTab.add({
              type: 'file',
              id: 'upload',
              label: 'Send it to the Server',
              size: 38,
            });
          }

          uploadButton['for'] = ['Upload', 'upload'];

          // Override upload button click
          uploadButton.onClick = function (evt) {
            const dialog = evt.sender.getDialog();
            const fileInput = dialog.getContentElement('Upload', 'upload').getInputElement().$;
            const file = fileInput.files[0];

            var invalidImage = this.$helpers.checkImgCkEditor(file);
            if (invalidImage)
              return;

            const formData = new FormData();
            formData.append('upload', file);

            fetch(editor.config.filebrowserUploadUrl, {
              method: 'POST',
              body: formData,
            })
              .then((res) => res.json())
              .then((data) => {
                if (data.uploaded === 1) {
                  dialog.getContentElement('info', 'txtUrl').setValue(data.url);
                  dialog.hide();
                } else {
                  const msg = (data.error && data.error.message) || 'Upload failed.';
                  alert(msg);
                  fileInput.value = '';
                }
              })
              .catch((err) => {
                alert('Upload error: ' + err.message);
                fileInput.value = '';
              });
          };
        }
      });

      // 🔹 Attach validation after the dialog actually appears
      var vm = this;
      editor.on('dialogShow', function (evt) {
        const dialog = evt.data;
        if (dialog.getName() !== 'image') return;

        // Wait for DOM to render
        setTimeout(() => {
          const uploadElement = dialog.getContentElement('Upload', 'upload');
          if (!uploadElement) return;

          const input = uploadElement.getInputElement().$;

          // remove old listener (avoid duplicates)
          input.removeEventListener('change', input._vueFileChangeHandler || (() => {}));

          // attach new listener
          input._vueFileChangeHandler = function () {
            const file = input.files[0];
            if (!file) return;

            var invalidImage = vm.$helpers.checkImgCkEditor(file);
            if (invalidImage) {
              input.value = '';
              return;
            }
          };

          input.addEventListener('change', input._vueFileChangeHandler);
        }, 100);
      });
    }
  }
};
</script>
